<template>
  <div class="resule-bottom">
    <div v-if="!execute.keys" class="result" style="color: #a60115; background: #fbf5f5; padding: 20px 0; margin: 0">
      {{ execute.msg }}
    </div>

    <div v-else-if=" resData && resData.length ">
      <!-- width="1000" -->
      <u-table  :max-height=" 400 " :data=" resData " :border=" false " :header-row-class-name=" () => 'u-table-class-name' ">
        <u-table-column align="center" v-for="(item, index2) in resColumns" :key=" item.key " :show-overflow-tooltip=" true " :prop=" item.key " :label=" item.title " :min-width=" 200 "
                        :width=" item.width ">
          <template slot-scope="scope">
            <HRender :fn=" item.render " v-bind=" { row: scope.row, column: { ...scope.column, _index: index2, ...item }, index: scope.$index } " v-if="item.render"></HRender>
            <span v-else>
              <span v-if="item.type === 'index'">{{ scope.$index + 1 }}</span>
              <span>{{ scope.row[item.key] }}</span>

            </span>
          </template>
        </u-table-column>
      </u-table>

      <div class="page_right">
        <Page :total=" totalNum " :current="pageIndex " @on-change=" changeIndex " />
      </div>
    </div>
    <el-empty v-else style="height: 350px;""></el-empty>
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from "vuex";
export default {
  props: {
    execute: Object, //查询数据
  },
  data() {
    return {
      resColumns: [], //表头
      resData: [], //数据
      totalNum: 1,
      pageIndex: 1,
      aaa: 1,
      replaceArr: [], //处理分页
    };
  },
  computed: {
    ...mapState({
      projectId: (state) => state.app.projectId,
    }),
  },
  created() {},
  watch: {
    execute(obj) {
      this.initTable(obj);
    },
  },
  components: {},
  mounted() {
    this.initTable(this.execute);
  },

  methods: {
    changeIndex(val) {
      // this.pageIndex = val
      this.resData = this.reSetData(this.replaceArr, 50)[val - 1];
    },
    //处理分页
    reSetData(dataList, num) {
      let arr = [];
      let len = dataList.length;
      for (let i = 0; i < len; i += num) {
        arr.push(dataList.slice(i, i + num));
      }
      return arr;
    },
    // 查询表格数据渲染
    initTable(baseData) {
      if (baseData.keys) {
        this.resData = [];
        this.resColumns = [
          {
            type: "index",
            width: 70,
            align: "center",
            fixed: "left",
          },
        ];
        baseData.keys.forEach((subItem) => {
          this.resColumns.push({
            title: subItem,
            key: subItem,
            minWidth: 150,
            // render: (h, params) => {
            //   return this.initUserPropCname(h, params);
            // },
          });
        });
        this.replaceArr = [];
        baseData.values.forEach((item, index) => {
          let dataItem = {};
          baseData.keys.forEach((subItem, subIndex) => {
            dataItem[subItem] = baseData.values[index][subIndex]
              ? baseData.values[index][subIndex]
              : "null";
          });
          this.replaceArr.push(dataItem);
        });
        this.pageIndex = 1;
        this.totalNum=parseInt(this.replaceArr.length/5)
        this.resData = this.reSetData(this.replaceArr, 50)[this.pageIndex - 1];
      }
    },

    initUserPropCname(h, { columns, index, row }) {
      for (let i in row) {
        return h("div", [
          h(
            "span",
            {
              // style: {
              //   display: row.editCname ? "none" : "inline-block",
              // },
            },
            row[i] ? row[i] : "null"
          ),
          // h("Icon", {
          //   style: {
          //     cursor: "pointer",
          //     marginLeft: "8px",
          //   },
          //   props: {
          //     type: "md-create",
          //   },
          //   on: {
          //     click: (evt) => {
          //       // this.showCnameEditor(evt, row);
          //     },
          //   },
          // }),
        ]);
      }
    },
  },
};
</script>

<style scoped>
.page_right{
  margin-top: 10px;
  display: flex;
  justify-content: flex-end;
}
.result {
  font-size: 30px;
  color: #d6d8db;
  display: flex;
  margin-top: 30px;
  justify-content: center;
}
.resule-bottom {
  /* padding: 20px; */
}
</style>



// WEBPACK FOOTER //
// src/views/customized-queries/components/results.vue